import React from 'react';

function PlansPage() {
    return <main className="plans"></main>;
}

export default PlansPage;
export { PlansPage };
